import * as React from 'react'

const KeyIcon = (props) => (
  <svg
    width={props.width}
    height={props.height}
    {...props}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#a)">
      <path
        d="M4.634 17.063c-.075 0-.157-.008-.225-.015l-1.627-.225c-.78-.105-1.485-.803-1.605-1.598l-.225-1.643c-.075-.525.15-1.207.525-1.59L4.769 8.7a6.212 6.212 0 0 1 1.65-5.932 6.254 6.254 0 0 1 8.82 0 6.194 6.194 0 0 1 1.823 4.41 6.194 6.194 0 0 1-1.823 4.41c-1.575 1.56-3.817 2.175-5.932 1.635l-3.3 3.292c-.315.33-.878.547-1.373.547ZM10.822 2.07a5.086 5.086 0 0 0-3.615 1.493A5.102 5.102 0 0 0 5.932 8.7a.56.56 0 0 1-.143.563l-3.525 3.524c-.127.128-.232.458-.21.63l.225 1.643c.045.285.353.607.638.645l1.635.225c.18.03.51-.075.637-.203l3.54-3.532a.56.56 0 0 1 .563-.135c1.807.57 3.78.082 5.13-1.268a5.089 5.089 0 0 0 1.492-3.614 5.076 5.076 0 0 0-1.492-3.615 5.045 5.045 0 0 0-3.6-1.493Z"
        fill="#64748B"
      />
      <path
        d="M6.891 15.405a.556.556 0 0 1-.397-.165l-1.725-1.725a.566.566 0 0 1 0-.795.566.566 0 0 1 .795 0l1.725 1.725a.566.566 0 0 1 0 .795.556.556 0 0 1-.398.165Z"
        fill="#475569"
      />
      <path
        d="M10.875 8.813a1.69 1.69 0 0 1-1.688-1.688c0-.93.758-1.688 1.688-1.688.93 0 1.688.758 1.688 1.688a1.69 1.69 0 0 1-1.688 1.688Zm0-2.25a.567.567 0 0 0-.563.562c0 .308.256.563.563.563a.567.567 0 0 0 .563-.563.567.567 0 0 0-.563-.563Z"
        fill="#64748B"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h18v18H0z" />
      </clipPath>
    </defs>
  </svg>
)

KeyIcon.defaultProps = {
  height: 18,
  width: 18
}

export { KeyIcon }
